import ReducerRegistry from "seneca-common/utils/state/reducer-registry";

import { PATH_TO_MEMORIES_STATE } from "./consts";
import memoriesReducer from "./reducers";

const reducerRegistry = ReducerRegistry.getInstance();
reducerRegistry.initialise(PATH_TO_MEMORIES_STATE, builder => {
  builder.register(PATH_TO_MEMORIES_STATE, memoriesReducer);
});

export { memoriesReducer, PATH_TO_MEMORIES_STATE };

// selectors
export {
  getMemoryForSection,
  makeGetMemoriesForCourse,
  noMemoriesStored,
  sectionHasMemory,
  getMemoriesCount,
  getMemories,
  getAllMemoryLocationIds,
  getMemoriesMap, // Memory selectors
  getMemoryId,
  getMemoryCourseId,
  getMemorySectionTitle,
  getMemoryLocationId,
  getMemoryTimeEarned
} from "./selectors";

export {
  memoriesAreFetching,
  memoriesFetchSucceeded,
  memoriesFetchErrored,
  memoriesFetchFinished,
  memoriesNeedFetching
} from "./selectors/meta";

// actions
export {
  saveMemoryLocally,
  receiveMemories,
  reconcileMemoriesLocally
} from "./actions";
export {
  fetchAllMemoriesActionFactory,
  createMemoryActionFactory
} from "./actions/meta";

// models

export { default as Memory } from "./models/state/memories/memory/Memory";
export type { MemoryType } from "./models/state/memories/memory/Memory";
